import 'react-hot-loader'
import { hot } from 'react-hot-loader/root'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'

import { ApolloProvider } from 'react-apollo'

import { store, history } from './store'

import { Provider } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { materialReds, materialGreens } from '@fe/ui/colors'

import { ENVIRONMENT } from './config'

import RootLayout from './containers/RootLayout'

import Auth from './pages/Auth/Auth'
import AutoLogin from './pages/Auth/AutoLogin'
import Connect from './pages/Auth/Connect'
import Login from './pages/Auth/Login'
import Welcome from './pages/Auth/Welcome'
import Signup from './pages/Auth/Signup'
import Buddies from './pages/Buddies'
import GamesList from './pages/GamesList'
import Game from './pages/Game'
import Claim from './pages/Claim'
import Review from './pages/Review'
import Profile from './pages/Profile'
import ResetPassword from './pages/Auth/ResetPassword'
import Home from './pages/Home'
import Clubs from './pages/Clubs'
import Offers from './pages/Offers'
import Offer from './pages/Offers/OfferPage'
import GLFROpen from './pages/Open'
import GLFROpenAccept from './pages/Open/Accept'
import GLFROpenUser from './pages/Open/user'
import GLFROpenApp from './pages/Open/App'
import GLFROpenExternal from './pages/Open/External'
import { Helmet } from 'react-helmet'
import apolloClient, { shopifyClient } from './apollo'

import CssBaseline from '@material-ui/core/CssBaseline'

import ReactGA from 'react-ga'

if (ENVIRONMENT === 'production') {
  ReactGA.initialize('UA-32172310-8')
  ReactGA.plugin.require('ecommerce')
}

const theme = createMuiTheme({
  palette: {
    primary: materialGreens,
    secondary: materialReds,
    error: materialReds
  },
  typography: {
    fontFamily: 'Open Sans',
    useNextVariants: true
  }
})

const CoolRoute = ({ path, title, component, extraProps }) => {
  const Rendered = component // must be PascalCase to render it
  return (
    <Route
      exact path={path} render={props => (
        <>
          <Helmet>
            <title>{title} - my.GLFR</title>
          </Helmet>
          <Rendered {...props} title={title} {...extraProps} />
        </>
      )}
    />
  )
}

const Routes = () => (
  <Switch>
    <CoolRoute path='/reset-password/:resetToken' title='Reset Password (confirm)' component={ResetPassword} />
    <CoolRoute path='/reset-password' title='Reset Password' component={ResetPassword} />

    <CoolRoute path='/auth/:resp' title='Auth' component={Auth} extraProps={{}} />
    <CoolRoute path='/login' title='Login' component={Login} extraProps={{}} />
    <CoolRoute path='/signup' title='Signup' component={Signup} extraProps={{ signup: true }} />
    <CoolRoute path='/autologin' title='Autologin' component={AutoLogin} extraProps={{}} />
    <CoolRoute path='/connect/:provider/:token' title='Connect' component={Connect} extraProps={{}} />

    <CoolRoute path='/welcome' title='Welcome to GLFR' component={Welcome} />

    <CoolRoute path='/claim/:token' title='Claim Game' component={Claim} />
    <CoolRoute path='/externalOpen/:externalId' title='Very Open Signup' component={GLFROpenExternal} />

    <CoolRoute exact path='/review/:unionId/:reviewId/key/:oauthKey' title='Review Game (Authenticated)' component={Review} />
    <CoolRoute exact path='/review/:unionId/:reviewId' title='Review Game' component={Review} />

    <RootLayout>
      <ApolloProvider client={apolloClient}>
        <CoolRoute path='/open' title='GLFR Open' component={GLFROpen} extraProps={{}} />
        <CoolRoute path='/open/register' title='GLFR Open' component={GLFROpen} extraProps={{ page: 'register' }} />
        <CoolRoute path='/open/register/app' title='GLFR Open' component={GLFROpenApp} extraProps={{}} />
        <CoolRoute path='/open/accept' title='GLFR Open' component={GLFROpenAccept} extraProps={{}} />
        <CoolRoute path='/' title='Golfer Profile' component={Home} />
        <CoolRoute path='/u/:userHandle' title='Golfer Profile' component={Home} />
        <CoolRoute path='/u/:userHandle/buddies' title='Buddies' component={Buddies} />
        <CoolRoute path='/u/:userHandle/games' title='Games' component={GamesList} />
        <CoolRoute path='/u/:userHandle/games/:gameId' title='Game Details' component={Game} />
        <CoolRoute path='/u/:userHandle/profile' title='Profile' component={Profile} />
        <CoolRoute path='/u/:userHandle/clubs' title='Clubs' component={Clubs} />
        <CoolRoute path='/u/:userHandle/open' title='GLFR Open' component={GLFROpenUser} />
      </ApolloProvider>
      <ApolloProvider client={shopifyClient}>
        <CoolRoute exact path='/offers/offer/:productHandle' title='Offer' component={Offer} />
        <CoolRoute exact path='/offers/:handle?' title='Offers' component={Offers} />
      </ApolloProvider>
    </RootLayout>
  </Switch>
)

const App = hot(() => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Provider store={store}>
      <div>
        <ConnectedRouter history={history}>
          <Routes />
        </ConnectedRouter>
      </div>
    </Provider>
  </ThemeProvider>
))

ReactDOM.render(<App />, document.getElementById('root'))
